import { render, staticRenderFns } from "./EventContestV2Detail.vue?vue&type=template&id=76c9f76a&scoped=true"
import script from "./EventContestV2Detail.vue?vue&type=script&lang=ts"
export * from "./EventContestV2Detail.vue?vue&type=script&lang=ts"
import style0 from "./EventContestV2Detail.vue?vue&type=style&index=0&id=76c9f76a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c9f76a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c9f76a')) {
      api.createRecord('76c9f76a', component.options)
    } else {
      api.reload('76c9f76a', component.options)
    }
    module.hot.accept("./EventContestV2Detail.vue?vue&type=template&id=76c9f76a&scoped=true", function () {
      api.rerender('76c9f76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContestV2Detail.vue"
export default component.exports